import AddNewStationBtn, { ModalBtnNewStation } from "./NewStationForm/AddNewStationBtn/AddNewStationBtn";
import NewStationFormPresenter from "./NewStationForm/NewStationFormPresenter";
import NewStationModal from "./NewStationModal/NewStationModal";

export const NewStation = {
    From: NewStationFormPresenter,
    ModalForm: NewStationModal,
    AddFormModal: ModalBtnNewStation,
    AddNewStationBtn: AddNewStationBtn
}

export default NewStation;